import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import { IUser } from 'types/db/user';

export interface ISignUpData {
    organizationName: string;
    name: string;
    email: string;
    workEmail: string;
    password?: string;
    picture?: string;
    isSandboxOrganization?: boolean;
    selfSignup?: boolean;
    termsAccepted?: boolean;
    auth0UserProfile?: string;
}

const signUpUserAndOrg = async (signupData: ISignUpData): Promise<IUser> => {
    const response = await axiosInstance.post(`${API_ENDPOINTS.SIGNUP.USER_AND_ORG}`, signupData);
    return response.data;
};

export const useSignUpUserAndOrg = () => useMutation({
    mutationFn: signUpUserAndOrg,
});

export default useSignUpUserAndOrg;
